<template>
  <tbody>
    <tr v-for="(item, i) in items" class="hovereable" :key="item.id">
      <td class="text-xs-center" width="120">
        <v-avatar
          size="45"
          class="transparent"
        >
          <v-icon large class="k-orange-linear-text">fas fa-at</v-icon>
        </v-avatar>
      </td>
      <td>
        <small>Propietario del email</small>
        {{ item.name }}
      </td>
      <td>
        <small>Email de plataforma</small>
        {{ item.email }}
      </td>
      <td>
        <v-chip small :class="{'white--text':true, 'green':item.status === 1, 'red':item.status === 0}">
          <v-icon small>{{item.status === 'activo' ? 'fas fa-check' : 'fas fa-times'}}</v-icon>
          &nbsp;&nbsp;
        {{ item.status == 1 ? 'Activo' : 'Inactivo' }}
        </v-chip>
      </td>
      <td class="text-xs-right">
        <v-menu left offset-x>
          <v-btn color="black" flat icon slot="activator">
            <v-icon small>fas fa-ellipsis-v</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="toggleStatus(item)">
              <v-list-tile-title>{{ item.status === 1 ? 'Desactivar' : 'Activar'}}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="editRow(item)">
              <v-list-tile-title>Editar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="deleteRow(item)">
              <v-list-tile-title>Eliminar</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </td>
    </tr>
  </tbody>
</template>

<script>
import EventBus from '@/event-bus';
import dataTableMixin from '@/mixins/dataTableList';

export default {
  mixins: [
    dataTableMixin,
  ],
  methods: {
    editRow(item) {
      this.$parent.$emit('editRow', item);
    },
    deleteRow(id) {
      this.$parent.$emit('deleteRow', id);
    },
    changeStatus(id, status) {
      this.axios.patch(`company_emails/${id}`, {
        status,
      }).then(() => {
        EventBus.$emit('update');
      }).catch(() => { });
    },
    toggleStatus(item) {
      const aux = {
        ...item,
      };
      aux.status = aux.status === 1 ? 0 : 1;
      this.$parent.$emit('toggleStatus', aux);
    },
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/chat_center_v2/config/ForwardingList.vue